import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _21mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"21mp"}/>
}
